var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcheckblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83316 8.84953L11.1954 3.4873L12.0203 4.31226L5.83316 10.4994L2.12085 6.78715L2.94581 5.9622L5.83316 8.84953Z",
    fill: "#3D3E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcheckblack);
export default __webpack_public_path__ + "static/media/icon.check.black.0710f764747e5894039e1d8cc45e18f6.svg";
export { ForwardRef as ReactComponent };